import { createContext } from "react";

const DF_LO0021Context = createContext();

export { DF_LO0021Context };